module.exports = __webpack_public_path__ + "static/media/  (163).88ea91d5.jpg";